const Messages = {
  AUTH: {
    EMAIL_REQUIRED: "Email cannot be empty.",
    OTP_REQUIRED: "OTP cannot be empty.",
    INVALID_EMAIL: "Enter a valid email address.",
    OTP_SENT: "OTP has been sent successfully.",
    OTP_RESENT: "OTP has been resent successfully.",
    OTP_FAILED: "Failed to send verification OTP. Retry again.",
    OTP_VERIFY_FAILED: "Failed to verification OTP. Retry again.",
    OTP_INVALID: "Enter a valid 6 digit OTP.",
    OTP_INCORRECT: "Incorrect OTP. Enter the correct code.",
    OTP_EXCEEDED: "OTP verification limit exceeded. Try again with a new OTP.",
    LOGIN_SUCCESS: "Login successfully!",
    LOGOUT_SUCCESS: "Logged out successfully.",
    TOKEN_MISSING: "Verification token is missing. Try again with a new OTP.",
    TOKEN_EXPIRED: "Your session has expired. Try again with a new OTP.",
    LOGIN_VERIFIED: "Account has been verified successfully.",
    PERMISSION_REQUIRED: "Permission Denied Contact Admin",
  },
  ERROR: {
    BAD_REQUEST: "Bad request. Check your input.",
    NETWORK_ERROR: "Network error. Please check your connection.",
    UNAUTHORIZED: "Unauthorized access. Please log in again.",
    UNKNOWN_ERROR: "An unexpected error occurred. Please try again.",
    SERVICE_UNAVAILABLE:
      "Service is currently unavailable. Please try again later.",
    UNAUTHORIZED_ACCESS: "Unauthorized access. Please log in again.",
    FORBIDDEN: "You do not have permission to access this resource.",
    NOT_FOUND: "The requested resource was not found.",
    TIMEOUT: "The request timed out. Please try again.",
    SERVER_ERROR: "An internal server error occurred.",
    URL_NOT_FOUND: "The requested endpoint was not found.",
    INVALID_RESPONSE_FORMAT:
      "The server returned an unexpected response. Please contact support.",
    SERVER_DOWN: "Connection to the server was refused.",
    INVALID_INPUT: "The input provided is invalid.",
    EMPTY_PHONE: "Phone cannot be empty.",
    INVALID_PHONE: "Enter a valid 10-digit phone numebr.",
    INVALID_PINCODE: "Enter a valid 6-digit pincode.",
    INVALID_GST_NUMBER: "Invalid GST number format.",
    INVALID_PAN_NUMBER: "Invalid PAN number format.",
    INVALID_CIN_NUMBER: "Invalid CIN number format.",
    CODE_EMPTY: "Code cannot be empty.",
    TITLE_EMPTY: "Title cannot be empty.",
    MRP_EMPTY: "MRP cannot be empty.",
    SALEPRICE_EMPTY: "Saleprice cannot be empty.",
    TAX_EMPTY: "Tax percentage cannot be empty.",
    BASEPRICE_EMPTY: "Baseprice cannot be empty.",
    TAXAMOUNT_EMPTY: "Taxamount cannot be empty.",
    DISCOUNT_EMPTY: "Discount cannot be empty.",
    CONFLICT: "There is a conflict with the current state of the resource.",
    INVALID_PAID_AMOUNT: "Paid amount should be equal to the total payable.",
    STOCK_EMPTY: "Stock cannot be empty.",
    STOCK_INVALID: "Enter a valid stock.",
    EMPTY_TITLE: "Title cannot be empty.",
    EMPTY_EMAIL: "Email cannot be empty.",
    INVALID_EMAIL: "Enter a valid email ID.",
    FIELD_REQUIRED: "This field cannot be empty.",
    EMPTY_STORE: "Store cannot be empty.",
    NO_STOCK: "No stock available for this product.",
    QUANTITY_MISMATCH: "Quantity mismatched with transfer quantity.",
    CROP_FAILED: "Failed to crop the image. Retry again.",
    UPLOAD_FAILED: "Failed to upload the image. Retry again.",
    AMOUNT_EMPTY: "Amount cannot be empty.",
    PAYMODE_EMPTY: "Payment mode cannot be empty.",
    EMPTY_CART: "Sale items cannot be empty.",
    INVALID_CHANGE_AMOUNT: "Change amount must be equal to total change.",
    CUSTOMER_EMPTY: "Customer cannot be empty",
    CHANGE_EXCEEDS_AMOUNT: "Change amount must be equal to total change.",
    MODE_EMPTY: "Sale mode cannot be empty.",
    NAME_EMPTY: "Name cannot be empty.",
    USER_NAME_EMPTY: "Username cannot be empty.",
    PASSWORD_EMPTY: "Password cannot be empty.",
    PASSWORD_TOO_SHORT: "Password must be at least 8 characters long.",
    PASSWORD_NO_NUMBER: "Password must include at least one number.",
    PASSWORD_NO_SPECIAL:
      "Password must include at least one special character.",
    REPASSWORD_EMPTY: "Confrim Password cannot be empty.",
    PASSWORD_MISMATCH: "Confirm Password should be match with Password.",
    PAYLATER_ERROR: "Customer Mandatory for PayLater",
    INVALID_PASSWORD:
      "Password must be at least 8 characters long, include one number, and one special character.",
  },
  SUCCESS: {
    PROFILE_UPDATED: "Profile updated successfully.",
    PASSWORD_CHANGED: "Password changed successfully.",
    OTP_SEND: "OTP sent successfully. Check your entred email.",
    CUSTOMER_ADDED: "Customer added successfully.",
    CUSTOMER_UPDATED: "Customer updated successfully.",
    CUSTOMER_DELETED: "Customer deleted successfully.",
    PRODUCT_ADDED: "Product added successfully.",
    PRODUCT_UPDATED: "Product updated successfully.",
    PRODUCT_DELETED: "Product deleted successfully.",
    STOCK_ADDED: "Stock added successfully.",
    STOCK_UPDATED: "Stock updated successfully.",
    STOCK_DELETED: "Stock deleted successfully.",
    STOCK_TRANSFER: "Stock transfered successfully.",
    SALE_ADDED: "Sale added successfully.",
    SALE_UPDATED: "Sale updated successfully.",
    SALE_DELETED: "Sale deleted successfully.",
    INVITATION_SEND: "Invitation sent successfully.",
    INVITATION_RESEND: "Invitation resent successfully.",
    INVITE_SUCCESS:
      "Your invitation accepted and account created successfully.",
    STORE_DELETED: "Store deleted successfully.",
    STOCK_ACCEPTED: "Stock accepted successfully.",
    SETTINGS_UPDATED: "Settings updated successfully.",
    IMAGE_UPLOADED: "Image updated successfully.",
    FILE_UPLOADED: "File uploaded successfully.",
    PAYLATER_ADDED: "Paylater added successfully.",
    CASH_ADDED: "Boxcash added successfully.",
    CASH_REMOVED: "Boxcash removed successfully.",
    EXPENSE_ADDED: "Expense added successfully.",
    EXPENSE_DELETED: "Expense has been deleted successfully.",
    ESTIMATE_DELETED: "Estimate deleted successfully.",
    PHONE_VERIFIED: "Phone number verified successfully.",
    STORE_CREATED: "Store created successfully.",
    RESET_SEND: "Password Reset link sent successfully to entred email.",
    STAFF_ADDED: "Staff has been added successfully.",
    STAFF_UPDATED: "Staff has been updated successfully.",
  },
  NETWORK: {
    ONLINE: "You are back online. Connection restored.",
    NO_INTERNET: "You are offline. check your internet connection.",
  },
};

export default Messages;
